module.exports = __webpack_public_path__ + "static/media/dof_small.c18b7db3.svg";